import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { studySubjectManagementServices } from "../../../../../APIServices/studySubjectManagementServices";
import { studyRandomizerMetadataServices } from "../../../../../APIServices/studyRandomizerMetadataServices";
import { studyFactorServices } from "../../../../../APIServices/studyFactorServices";
import { PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";

const UpdateSubject = ({ siteId, subjectId, getStudySiteSubjectList, Show, Hide, Title, setSubjectId, subjectSettings }) => {
  const [subjectRow, setSubjectRow] = useState("");
  const [subjectColumns, setSubjectColumns] = useState([]);
  const [screeningDate, setScreeningDate] = useState("");
  const [randomizerId, setRandomizerId] = useState("");
  const [randomizerName, setRandomizerName] = useState("");
  const [manualRandomizationNumber, setManualRandomizationNumber] = useState("");
  const [manualScreeningNumber, setManualScreeningNumber] = useState("");
  const [factors, setFactors] = useState([]);
  const [randomizerList, setRandomizerList] = useState([]);
  const [factorList, setFactorList] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams()
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const getStudySubjectColumnData = async (e) => {
    setLoader(true)
    let data = await studySubjectManagementServices.getStudySubjectColumnData("active", studyId, siteId);
    let customColumn = [
      { columnLabel: 'Screen Id', columnName: 'SCREENID', columnType: 'text', type: "predefine" },
      { columnLabel: 'Random Number', columnName: 'RANDOMNUMBER', columnType: 'text', type: "predefine" },
    ]
    let finalColumn
    if (subjectSettings === "IWRS") {
      finalColumn = [...(data?.data || []), ...customColumn]
    } else {
      finalColumn = [...(data?.data || [])]
    }
    setSubjectColumns(finalColumn);
    setLoader(false)
  };

  const handleSubjectRowChange = (e, columnKey) => {
    setSubjectRow({
      ...subjectRow,
      [columnKey]: e.target.value,
    });
  };

  const updateStudySubjectRowData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Subject!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        userData.subjectId = subjectId;
        userData.siteId = siteId;
        userData.studyId = studyId;
        userData.screeningDate = screeningDate;
        userData.manualRandomizationNumber = manualRandomizationNumber;
        userData.manualScreeningNumber = manualScreeningNumber;
        if (subjectSettings === "IWRS") {
          userData.randomizerId = randomizerId;
        }
        userData.subjectRow = subjectRow
        let data = await studySubjectManagementServices.updateStudySubjectRowData(userData);
        if (data?.statusCode === 200) {
          getStudySiteSubjectList();
          Hide()
          setSubjectId("")
        }
        setButtonLoader(false)
      }
    });
  };

  const getAssigedFactorinSites = async (e) => {
    let data = await studyFactorServices.getAssigedFactorinSites(
      studyId,
      siteId
    );
    setFactorList(data?.data || []);
  };

  useEffect(() => {
    if (siteId) {
      getStudySubjectColumnData();
      getAssigedFactorinSites()
    }
  }, [siteId]);

  const getAssignedRandomizerList = async (e) => {
    let data = await studyRandomizerMetadataServices.getAssignedRandomizerList(
      studyId,
      StudyMode
    );
    setRandomizerList(data?.data || []);
  };

  useEffect(() => {
    getAssignedRandomizerList()
  }, []);

  const getStudySingleSubjectRow = async () => {
    let data = await studySubjectManagementServices.getStudySingleSubjectRow(studyId, siteId, subjectId)
    setSubjectRow(data?.data?.row);
    setScreeningDate(data?.data?.screeningDate)
    setFactors(data?.data?.factors || [])
    setManualRandomizationNumber(data?.data?.manualRandomizationNumber)
    setManualScreeningNumber(data?.data?.manualScreeningNumber)
    setRandomizerId(data?.data?.randomizerId || "")
    setRandomizerName(data?.randomizationName)
  }

  useEffect(() => {
    if (siteId && subjectId) {
      getStudySingleSubjectRow();
    }
  }, [siteId, subjectId]);

  function isRowDataComplete() {
    let subjectColumnData = (subjectSettings === "IWRS" || subjectSettings === "Auto") ? subjectColumns?.filter(item => !(item?.columnName === "SUBJECTID" || item?.columnName === "SCREENID" || item?.columnName === "RANDOMNUMBER")) : subjectColumns
    if (subjectColumnData?.length > 0) {
      return subjectColumnData.every(col => {
        const key = col.columnName;
        return subjectRow?.hasOwnProperty(key) && subjectRow[key] !== "" && subjectRow[key] !== null && subjectRow[key] !== undefined;
      });
    } else {
      return false
    }
  }
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton >
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {loader ? (
            <PageLoader />
          ) : (
            <>
              {subjectColumns?.map((item, index) => (
                <Form.Group key={index} className="mb-2">
                  <Form.Label className="fw-bold mb-1">
                    {item?.columnLabel}
                    {!["ID"].some(sub => item?.columnName?.toUpperCase().includes(sub)) && (
                      <abbr title="Required" className="text-danger"> *</abbr>
                    )}
                  </Form.Label>
                  {item?.columnType === "dropdown" ?
                    <Form.Select
                      onChange={(e) => handleSubjectRowChange(e, item?.columnName)}
                      className="br3" style={{ fontSize: 12 }}>
                      <option value="">Select Option</option>
                      {(item?.columnOption || [])?.map((el, i) => (
                        <option index={i} selected={subjectRow?.[item?.columnName] === el?.option} value={el?.option}>{el?.option}</option>
                      ))}
                    </Form.Select>
                    : item?.columnType === "radio" ?
                      (item?.columnOption || [])?.map((el, i) => (
                        <Form.Check
                          key={i}
                          type="radio"
                          label={el?.option}
                          name={item?.columnName}
                          value={el?.option}
                          checked={subjectRow?.[item?.columnName] === el?.option}
                          onChange={(e) => handleSubjectRowChange(e, item?.columnName)}
                          className="br3"
                        />
                      ))
                      :
                      <Form.Control
                        onChange={(e) => handleSubjectRowChange(e, item?.columnName)}
                        value={subjectRow?.[item?.columnName] || ""}
                        className="br3"
                        disabled={(subjectSettings === "IWRS" || subjectSettings === "Auto") && (item.columnName === "SUBJECTID" || item.columnName === "SCREENID" || item.columnName === "RANDOMID" || item.columnName === "RANDOMNUMBER")}
                        placeholder={`Enter ${item?.columnLabel}`}
                        type={item?.columnType}
                      />
                  }
                </Form.Group>
              ))}
              <Form.Group className="mb-1">
                <Form.Label className="fw-bold mb-1">
                  Screening Date{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Control
                  onChange={(e) => setScreeningDate(e.target.value)}
                  value={screeningDate}
                  className="br3"
                  type="date"
                />
              </Form.Group>
              <Form.Group className="mb-1">
                <Form.Label className="fw-bold mb-1">
                  Randomization No. (Manual)
                </Form.Label>
                <Form.Control
                  onChange={(e) => setManualRandomizationNumber(e.target.value)}
                  value={manualRandomizationNumber}
                  required
                  placeholder="Enter Randomization No. (Manual)"
                  className="br3"
                  type="text"
                />
              </Form.Group>
              <Form.Group className="mb-1">
                <Form.Label className="fw-bold mb-1">
                  Screening No. (Manual)
                </Form.Label>
                <Form.Control
                  onChange={(e) => setManualScreeningNumber(e.target.value)}
                  value={manualScreeningNumber}
                  required
                  placeholder="Enter Screening No. (Manual)"
                  className="br3"
                  type="text"
                />
              </Form.Group>
              {subjectSettings === "IWRS" &&
                <>
                  {factorList?.map((item, index) => (
                    <Form.Group className="mb-2" key={index}>
                      <Form.Label className="fw-bold mb-1">
                        {item?.label}{" "}
                        <abbr title="Required" className="text-danger">
                          *
                        </abbr>
                      </Form.Label>
                      <Form.Select
                        value={factors[index]?.value || ""}
                        style={{ fontSize: 12 }}
                        disabled
                        className="br3"
                      >
                        <option value="">Select {item?.label}</option>
                        {(item?.factors || []).map((subItem, subIndex) => (
                          <option key={subIndex} value={subItem?.factor}>
                            {subItem?.option}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  ))}
                  <Form.Group className="mb-1">
                    <Form.Label className="fw-bold mb-1">
                      Randomizer
                    </Form.Label>
                    {subjectRow?.SUBJECTID ?
                      <Form.Control
                        value={randomizerName}
                        disabled
                        className="br3"
                        type="text"
                      />
                      :
                      <Form.Select
                        style={{ fontSize: 12 }}
                        className="br3"
                        disabled={subjectRow?.SUBJECTID}
                        onChange={(e) => setRandomizerId(e.target.value)}
                      >
                        <option selected={randomizerId === ""} value="">Select Randomizer</option>
                        {randomizerList?.map((item, index) => (
                          <option key={index} selected={randomizerId === item?.randomizerId} value={item?.randomizerId}>{item?.name}</option>
                        ))}
                      </Form.Select>
                    }
                  </Form.Group>
                </>
              }
            </>
          )}
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={buttonLoader || isRowDataComplete()}
            onClick={updateStudySubjectRowData}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Subject"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateSubject;
